export type DocumentVariableGroup =
  | 'client'
  | 'case'
  | 'lead'
  | 'product'
  | 'office'
  | 'lawyer'
  | 'finance'
  | 'system'
  | 'manual';

export type DocumentVariableDefinition = {
  key: string;
  label: string;
  group: DocumentVariableGroup;
  required: boolean;
};

export const DOCUMENT_VARIABLE_GROUP_LABELS:
  Record<DocumentVariableGroup, string> = {
    client: 'Cliente',
    case: 'Caso / Processo',
    lead: 'Lead',
    product: 'Produto jurídico',
    office: 'Escritório',
    lawyer: 'Advogado',
    finance: 'Financeiro',
    system: 'Sistema',
    manual: 'Personalizadas',
  };

export const DOCUMENT_VARIABLE_CATALOG:
  DocumentVariableDefinition[] = [
    { key: 'clientName', label: 'Nome do cliente', group: 'client', required: false },
    { key: 'clientCpfCnpj', label: 'CPF / CNPJ do cliente', group: 'client', required: false },
    { key: 'clientRg', label: 'RG do cliente', group: 'client', required: false },
    { key: 'clientNationality', label: 'Nacionalidade do cliente', group: 'client', required: false },
    { key: 'clientCivilStatus', label: 'Estado civil do cliente', group: 'client', required: false },
    { key: 'clientProfession', label: 'Profissão do cliente', group: 'client', required: false },
    { key: 'clientPhone', label: 'Telefone do cliente', group: 'client', required: false },
    { key: 'clientEmail', label: 'E-mail do cliente', group: 'client', required: false },
    { key: 'clientAddress', label: 'Endereço completo do cliente', group: 'client', required: false },
    { key: 'clientCity', label: 'Cidade do cliente', group: 'client', required: false },
    { key: 'clientState', label: 'Estado do cliente', group: 'client', required: false },

    { key: 'caseTitle', label: 'Título do caso', group: 'case', required: false },
    { key: 'caseNumber', label: 'Número do processo', group: 'case', required: false },
    { key: 'caseCourt', label: 'Juízo / Tribunal', group: 'case', required: false },
    { key: 'caseLegalArea', label: 'Área jurídica', group: 'case', required: false },
    { key: 'caseOpposingParty', label: 'Parte contrária', group: 'case', required: false },
    { key: 'caseValue', label: 'Valor do caso', group: 'case', required: false },

    { key: 'leadName', label: 'Nome do lead', group: 'lead', required: false },
    { key: 'leadPhone', label: 'Telefone do lead', group: 'lead', required: false },
    { key: 'leadEmail', label: 'E-mail do lead', group: 'lead', required: false },

    { key: 'legalProductName', label: 'Produto jurídico', group: 'product', required: false },

    { key: 'officeName', label: 'Nome do escritório', group: 'office', required: false },
    { key: 'officeLegalName', label: 'Razão social do escritório', group: 'office', required: false },
    { key: 'officeDocumentNumber', label: 'CNPJ / documento do escritório', group: 'office', required: false },
    { key: 'officeWebsite', label: 'Site do escritório', group: 'office', required: false },
    { key: 'officeEmail', label: 'E-mail do escritório', group: 'office', required: false },
    { key: 'officePhone', label: 'Telefone do escritório', group: 'office', required: false },
    { key: 'officeWhatsapp', label: 'WhatsApp do escritório', group: 'office', required: false },
    { key: 'officeInstagram', label: 'Instagram do escritório', group: 'office', required: false },
    { key: 'officeAddress', label: 'Endereço completo do escritório', group: 'office', required: false },
    { key: 'officeAddressLine', label: 'Logradouro do escritório', group: 'office', required: false },
    { key: 'officeAddressNumber', label: 'Número do escritório', group: 'office', required: false },
    { key: 'officeAddressComplement', label: 'Complemento do escritório', group: 'office', required: false },
    { key: 'officeDistrict', label: 'Bairro do escritório', group: 'office', required: false },
    { key: 'officeCity', label: 'Cidade do escritório', group: 'office', required: false },
    { key: 'officeState', label: 'Estado do escritório', group: 'office', required: false },
    { key: 'officeZipCode', label: 'CEP do escritório', group: 'office', required: false },
    { key: 'officeCountry', label: 'País do escritório', group: 'office', required: false },

    { key: 'lawyerName', label: 'Nome do advogado', group: 'lawyer', required: false },
    { key: 'lawyerDocument', label: 'Documento do advogado', group: 'lawyer', required: false },
    { key: 'lawyerOab', label: 'Número da OAB', group: 'lawyer', required: false },
    { key: 'lawyerOabState', label: 'UF da OAB', group: 'lawyer', required: false },
    { key: 'lawyerEmail', label: 'E-mail do advogado', group: 'lawyer', required: false },
    { key: 'lawyerPhone', label: 'Telefone do advogado', group: 'lawyer', required: false },
    { key: 'lawyerRole', label: 'Qualificação do advogado', group: 'lawyer', required: false },

    { key: 'bankName', label: 'Banco', group: 'finance', required: false },
    { key: 'bankAgency', label: 'Agência', group: 'finance', required: false },
    { key: 'bankAccount', label: 'Conta bancária', group: 'finance', required: false },
    { key: 'bankAccountType', label: 'Tipo de conta', group: 'finance', required: false },
    { key: 'pixKey', label: 'Chave PIX', group: 'finance', required: false },
    { key: 'pixKeyType', label: 'Tipo da chave PIX', group: 'finance', required: false },
    { key: 'paymentHolderName', label: 'Nome do favorecido', group: 'finance', required: false },
    { key: 'paymentHolderDocument', label: 'Documento do favorecido', group: 'finance', required: false },

    { key: 'defaultCity', label: 'Cidade padrão', group: 'system', required: false },
    { key: 'defaultState', label: 'Estado padrão', group: 'system', required: false },
    { key: 'defaultForum', label: 'Foro padrão', group: 'system', required: false },
    { key: 'currentDate', label: 'Data atual', group: 'system', required: false },
    { key: 'documentFooter', label: 'Rodapé padrão', group: 'system', required: false },
    { key: 'signatureText', label: 'Assinatura padrão', group: 'system', required: false },
    { key: 'contractObservations', label: 'Observações padrão de contrato', group: 'system', required: false },
    { key: 'powerOfAttorneyObservations', label: 'Observações padrão de procuração', group: 'system', required: false },
  ];

export const DOCUMENT_VARIABLE_CATALOG_BY_KEY =
  new Map(
    DOCUMENT_VARIABLE_CATALOG.map(
      (item) => [
        item.key,
        item,
      ]
    )
  );

const VARIABLE_PATTERN =
  /{{\s*([a-zA-Z0-9_]+)\s*}}/g;

export function extractDocumentVariables(
  content: unknown
) {
  const text =
    String(content ?? '');

  const result: string[] = [];
  const seen =
    new Set<string>();

  for (
    const match of
      text.matchAll(VARIABLE_PATTERN)
  ) {
    const key =
      String(
        match[1] ?? ''
      ).trim();

    if (
      !key ||
      seen.has(key)
    ) {
      continue;
    }

    seen.add(key);
    result.push(key);
  }

  return result;
}

export function normalizeDocumentTags(
  value: unknown
) {
  const raw =
    Array.isArray(value)
      ? value
      : String(value ?? '')
          .split(/[\n,;]+/g);

  const result: string[] = [];
  const seen =
    new Set<string>();

  for (const item of raw) {
    const text =
      String(item ?? '')
        .trim();

    if (!text) {
      continue;
    }

    const normalized =
      text.toLocaleLowerCase(
        'pt-BR'
      );

    if (
      seen.has(normalized)
    ) {
      continue;
    }

    seen.add(normalized);
    result.push(text);
  }

  return result;
}

export function buildVariableDefinitions(
  keys: string[],
  current:
    DocumentVariableDefinition[] = [],
  requiredKeys:
    string[] = []
): DocumentVariableDefinition[] {
  const currentByKey =
    new Map(
      current.map(
        (item) => [
          item.key,
          item,
        ]
      )
    );

  const required =
    new Set(requiredKeys);

  return keys.map(
    (key) => {
      const catalog =
        DOCUMENT_VARIABLE_CATALOG_BY_KEY.get(
          key
        );

      const existing =
        currentByKey.get(key);

      return {
        key,

        label:
          existing?.label ??
          catalog?.label ??
          key,

        group:
          existing?.group ??
          catalog?.group ??
          'manual',

        required: required.has(key),
      };
    }
  );
}

export function getUnknownDocumentVariables(
  keys: string[]
) {
  return keys.filter(
    (key) =>
      !DOCUMENT_VARIABLE_CATALOG_BY_KEY.has(
        key
      )
  );
}